import { render, staticRenderFns } from "./BookShelfList.vue?vue&type=template&id=0383cb5e&scoped=true&"
import script from "./BookShelfList.vue?vue&type=script&lang=js&"
export * from "./BookShelfList.vue?vue&type=script&lang=js&"
import style0 from "./BookShelfList.vue?vue&type=style&index=0&id=0383cb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383cb5e",
  null
  
)

export default component.exports